import React, { createContext } from 'react';

export const ConfigContext = createContext({});

export const ConfigProvider = ({ children, config }) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);
